// Formatting for token counts and model spend.
//
// Embedding costs are tiny — a ten-token question at $0.02/1M is $0.0000002 —
// so the usual four decimals would print every one of them as "$0.0000" and
// make the whole column look free. Precision follows the magnitude instead.

/** "$0.0123", "$0.000002", "<$0.000001", or "—" when the price is unknown. */
export function formatUsd(value: number | null | undefined): string {
  if (value == null) return "—";
  if (value === 0) return "$0";
  if (value < 0.000001) return "<$0.000001";
  if (value < 0.01) return `$${value.toFixed(6)}`;
  return `$${value.toFixed(4)}`;
}

export function formatTokens(value: number | null | undefined): string {
  return value == null ? "—" : value.toLocaleString();
}

/** Sum of the known costs; null only when none is known. */
export function sumCosts(...values: (number | null | undefined)[]): number | null {
  const known = values.filter((v): v is number => v != null);
  return known.length ? known.reduce((a, b) => a + b, 0) : null;
}
